export class VendorManufacturerItemDto {
  itemId: string;
  vendorId: string;
  manufacturerId: string;
  vendorName: string;
  vendorPartNumber: string;
  manufacturerName: string;
  manufacturerPartNumber: string;
  unitPrice: number;
  unitOfMeasure: string;
}
